import { DRAWER_TYPES } from './DrawerStack.constants';

export const SAVE_CONFIG = {
  [DRAWER_TYPES.CallEditor]: {
    handler: async () => ({})
  },
  [DRAWER_TYPES.CreateSendout]: {
    handler: async () => ({})
  },
  [DRAWER_TYPES.CreateSendover]: {
    handler: async () => ({})
  }
};
